// import "./splide";
// import "./mobile-menu";
// import "./form-validation";
// import "./popup";

/*
// language switcher
*/
// add svg to language switcher
let switcher = document.querySelectorAll(".lang .menu-item-has-children");
switcher.forEach((element) => {
  let button = document.createElement("button");
  button.classList.add("carret");
  button.innerHTML =
    "<svg width='11' height='8' viewBox='0 0 11 8' fill='white' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M9.88805 1.2474C10.2786 1.63787 10.2787 2.27104 9.88822 2.66161L5.79822 6.75261C5.6107 6.94018 5.35633 7.04557 5.09109 7.04559C4.82585 7.04561 4.57147 6.94025 4.38392 6.7527L0.292924 2.6617C-0.0976009 2.27117 -0.0976009 1.63801 0.292924 1.24748C0.683448 0.856959 1.31661 0.856959 1.70714 1.24748L5.09094 4.63129L8.47384 1.24757C8.86431 0.856998 9.49748 0.85692 9.88805 1.2474Z'/></svg>";
  element.append(button);
});
// add hover class to menu-items
const menuItems = document.querySelectorAll(".lang .menu-item");
menuItems.forEach((item) => {
  item.addEventListener("click", () => {
    item.classList.toggle("hover"); 
  });
});
window.addEventListener("click", (event) => {
  const targetElement = event.target;
  const menuItemsArray = Array.from(menuItems);
  const isMenuItem = menuItemsArray.some((item) =>
    item.contains(targetElement)
  );
  if (!isMenuItem) {
    menuItems.forEach((item) => {
      item.classList.remove("hover");
    });
  }
});

/*
// button--link
*/
// add svg to button--link's
let buttons = document.querySelectorAll(".button--link");
[].forEach.call(buttons, function (addBefore) {
  addBefore.innerHTML +=
    '<svg width="7" height="11" viewBox="0 0 7 11" fill="white" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.363211 0.292888C0.753739 -0.0976336 1.3869 -0.0976286 1.77742 0.292899L5.86736 4.3829C6.25784 4.77339 6.25788 5.40648 5.86745 5.79701L1.77751 9.88801C1.38704 10.2786 0.753873 10.2787 0.363298 9.8882C-0.0272773 9.49773 -0.0273597 8.86456 0.363114 8.47399L3.74613 5.09009L0.3632 1.7071C-0.0273211 1.31657 -0.0273161 0.683409 0.363211 0.292888Z"/></svg>';
});

/*
// to top button
*/
let scrollToTopButton = document.getElementById("js-top");
if (scrollToTopButton) {
  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      document.body.scrollTop > 300 ||
      document.documentElement.scrollTop > 300
    ) {
      scrollToTopButton.classList.add("show");
    } else {
      scrollToTopButton.classList.remove("show");
    }
  }

  scrollToTopButton.onclick = function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };
}

/*
// move div to another stack
*/
// move to another stack (tablet)
function moveToAnotherStack() {
  const id = document.querySelector("#contacts");

  let movedItem1 = id.querySelector(".contacts__inner-to");
  let referenceNode1 = id.querySelector(".contacts__inner-po");
  let destination1 = id.querySelector(".contacts__inner-col:first-child");
  destination1.insertBefore(movedItem1, referenceNode1.nextSibling);

  let movedItem2 = id.querySelector(".contacts__inner-mo");
  let referenceNode2 = id.querySelector(".contacts__inner-socials");
  let destination2 = id.querySelector(".contacts__inner-col:last-child");
  destination2.insertBefore(movedItem2, referenceNode2);
}
// move to "home" stack (tablet)
function moveToHome() {
  const id = document.querySelector("#contacts");

  let movedItem1 = id.querySelector(".contacts__inner-to");
  let referenceNode1 = id.querySelector(".contacts__inner-socials");
  let destination1 = id.querySelector(".contacts__inner-col:last-child");
  destination1.insertBefore(movedItem1, referenceNode1);

  let movedItem2 = id.querySelector(".contacts__inner-mo");
  let referenceNode2 = id.querySelector(".mo-marker");
  let destination2 = id.querySelector(".contacts__inner-col:nth-child(2)");
  destination2.insertBefore(movedItem2, referenceNode2);
}
// init on tablet
let idBlock = document.querySelector("#contacts");
if (document.body.contains(idBlock)) {
  // fire then resize window
  function handleResize() {
    if (window.innerWidth <= 1024) {
      moveToAnotherStack();
    } else {
      moveToHome();
    }
  }
  // window.addEventListener("resize", handleResize);

  // // fire then window smaller then ...
  // if (window.matchMedia("(max-width: 1024px)").matches) {
  //   moveToAnotherStack();
  // }
}
// {
//   // move to another stack (mobile)
//   function moveToAnotherStack2() {
//     const id = document.querySelector("#contacts");

//     let movedItem1 = id.querySelector(".contacts__inner-mo");
//     let referenceNode1 = id.querySelector(".contacts__inner-po");
//     let destination1 = id.querySelector(".contacts__inner-col:first-child");
//     destination1.insertBefore(movedItem1, referenceNode1.nextSibling);
//   }
//   // move to "home" stack (mobile)
//   function moveToHome2() {
//     const id = document.querySelector("#contacts");

//     let movedItem1 = id.querySelector(".contacts__inner-mo");
//     let referenceNode1 = id.querySelector(".contacts__inner-socials");
//     let destination1 = id.querySelector(".contacts__inner-col:last-child");
//     destination1.insertBefore(movedItem1, referenceNode1);
//   }
//   // init on mobile
//   let idBlock2 = document.querySelector("#contacts");
//   if (document.body.contains(idBlock2)) {
//     // fire then resize window
//     function handleResize2() {
//       if (window.innerWidth <= 600) {
//         moveToAnotherStack2();
//       } else {
//         moveToHome2();
//       }
//     }
//     window.addEventListener("resize", handleResize2);

//     // fire then window smaller then ...
//     if (window.matchMedia("(max-width: 600px)").matches) {
//       moveToAnotherStack2();
//     }
//   }
// }
/*
// END move div to another stack
*/

/*
// ihover block
*/
jQuery(document).ready(function () {
  var initialImage = jQuery(".ihover__column:first").find("img");
  var initialBackgroundImg = initialImage.attr("src");
  var initialAlt = initialImage.attr("alt");
  var initialTitle = initialImage.attr("title");
  var initialSrcset = initialImage.attr("srcset");

  jQuery(".ihover__inner").prepend(
    '<div class="ihover__background"><img src="' +
    initialBackgroundImg +
    '" alt="' +
    initialAlt +
    '" title="' +
    initialTitle +
    '" srcset="' +
    initialSrcset +
    '" /></div>'
  );

  jQuery(".ihover__column").hover(
    function () {
      var image = jQuery(this).find("img");
      var backgroundImg = image.attr("src");
      var alt = image.attr("alt");
      var title = image.attr("title");
      var srcset = image.attr("srcset");

      jQuery(".ihover__background img").addClass("hidden");
      setTimeout(function () {
        jQuery(".ihover__background img")
          .attr({
            src: backgroundImg,
            alt: alt,
            title: title,
            srcset: srcset,
            width: "1920",
            height: "600"
          })
          .removeClass("hidden");
      }, 300);
    },
    function () {
      jQuery(".ihover__background img").addClass("hidden");
      setTimeout(function () {
        jQuery(".ihover__background img")
          .attr({
            src: initialBackgroundImg,
            alt: initialAlt,
            title: initialTitle,
            srcset: initialSrcset,
          })
          .removeClass("hidden");
      }, 300);
    }
  );
});
// add svg to ihoverLink
let ihoverLink = document.querySelectorAll(".ihover__link");
ihoverLink.forEach((element) => {
  let svgArrow = document.createElement("span");
  svgArrow.classList.add("ihover__link-svg");
  svgArrow.innerHTML =
    '<svg width="7" height="11" viewBox="0 0 7 11" fill="#FEBF48" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.292807 0.29298C0.683283 -0.0975924 1.31645 -0.0976698 1.70702 0.292807L5.79802 4.38281C5.98559 4.57034 6.09098 4.8247 6.091 5.08994C6.09102 5.35518 5.98566 5.60956 5.79811 5.79711L1.70711 9.88811C1.31658 10.2786 0.683417 10.2786 0.292893 9.88811C-0.0976311 9.49758 -0.0976311 8.86442 0.292893 8.47389L3.6767 5.09009L0.29298 1.70719C-0.0975923 1.31672 -0.0976697 0.683552 0.292807 0.29298Z" /></svg>';
  element.append(svgArrow);
});

/*
// banner block
*/
// add svg to banner
let banner = document.querySelectorAll(".banner");
banner.forEach((element) => {
  let svgImage = document.createElement("div");
  svgImage.classList.add("banner__svg");
  svgImage.innerHTML =
    '<svg width="1111" height="1111" viewBox="0 0 1111 1111" fill="none" xmlns="http://www.w3.org/2000/svg"><g style="mix-blend-mode:overlay"><path d="M642.509 918.941C613.657 925.392 584.18 928.634 554.615 928.609C505.658 929.208 457.081 919.945 411.78 901.371C366.478 882.798 325.38 855.295 290.933 820.5C256.745 785.49 229.724 744.138 211.389 698.768C192.559 653.519 182.995 604.952 183.263 555.942C182.993 507.216 192.559 458.936 211.389 413.994C230.617 368.831 258.37 327.798 293.131 293.141C308.755 278.383 325.505 264.865 343.23 252.711L265.444 82.6373C228.266 105.15 193.893 131.999 163.048 162.62C112.474 213.062 72.0452 272.735 43.9513 338.406C14.7003 406.724 -0.255666 480.307 0.00434788 554.623C-0.293003 628.943 14.6645 702.534 43.9513 770.841C100.209 904.471 206.522 1010.78 340.154 1067.04C408.397 1096.53 482.032 1111.5 556.373 1110.99C611.475 1111.07 666.281 1102.92 718.977 1086.82L642.509 918.941Z" fill="#FDBE48"/><path d="M1068.78 339.712C1012.43 206.247 906.124 100.104 772.575 43.9511C704.268 14.6646 630.677 -0.29281 556.356 0.00453796C501.42 -0.218488 446.76 7.78047 394.192 23.7357L470.659 193.809C498.714 186.953 527.476 183.413 556.356 183.262C605.394 182.911 654.012 192.311 699.385 210.915C744.758 229.519 785.98 256.956 820.656 291.632C855.331 326.307 882.769 367.529 901.373 412.901C919.977 458.274 929.377 506.892 929.027 555.929C929.164 604.842 919.914 653.328 901.779 698.755C883.108 744.37 855.46 785.767 820.477 820.487C805.365 835.425 789.049 849.094 771.696 861.357L847.285 1029.23C945.862 968.916 1022.79 878.912 1067.02 772.146C1096.31 703.839 1111.26 630.249 1110.97 555.929C1111.78 481.735 1097.43 408.157 1068.78 339.712Z" fill="#FDBE48"/></g></svg>';
  element.prepend(svgImage);
});

/*
// timeline2 block
*/
// add svg to ihoverLink
let timelineItem = document.querySelectorAll(".itl2__column");
timelineItem.forEach((element) => {
  let borderDiv = document.createElement("div");
  borderDiv.classList.add("itl2__column-border");
  element.append(borderDiv);
});

/*
// title-text block
*/
// add svg to title-text
let titleTextBlock = document.querySelectorAll(".title-text");
titleTextBlock.forEach((element) => {
  let decor = document.createElement("div");
  decor.classList.add("decor");
  decor.innerHTML =
    '<svg width="500" height="500" viewBox="0 0 500 500" fill="#FEB736" xmlns="http://www.w3.org/2000/svg"><g opacity="0.7"><path d="M289.158 413.565C276.173 416.468 262.907 417.927 249.602 417.916C227.569 418.185 205.707 414.017 185.319 405.658C164.932 397.299 146.435 384.921 130.933 369.262C115.547 353.506 103.386 334.896 95.1347 314.477C86.66 294.113 82.3559 272.256 82.4767 250.199C82.355 228.27 86.6603 206.542 95.1347 186.316C103.788 165.991 116.278 147.524 131.922 131.927C138.953 125.285 146.492 119.201 154.469 113.731L119.462 37.1905C102.73 47.3223 87.2605 59.4056 73.3788 73.1864C50.6185 95.8873 32.4236 122.743 19.7801 152.298C6.61578 183.044 -0.115099 216.16 0.0019131 249.606C-0.131914 283.053 6.59964 316.172 19.78 346.913C45.0984 407.053 92.9443 454.898 153.085 480.216C183.797 493.49 216.936 500.225 250.393 499.994C275.191 500.03 299.856 496.363 323.572 489.116L289.158 413.565Z"/><path d="M480.998 152.886C455.637 92.8205 407.797 45.0514 347.694 19.78C316.952 6.59977 283.833 -0.131728 250.385 0.00208607C225.662 -0.0982902 201.062 3.5016 177.404 10.6822L211.818 87.2228C224.444 84.1374 237.388 82.5443 250.385 82.4761C272.454 82.3183 294.335 86.5486 314.755 94.9213C335.174 103.294 353.726 115.642 369.332 131.247C384.938 146.853 397.286 165.405 405.658 185.824C414.031 206.244 418.262 228.124 418.104 250.193C418.166 272.206 414.003 294.027 405.841 314.471C397.438 335 384.995 353.63 369.252 369.256C362.45 375.979 355.108 382.131 347.298 387.65L381.316 463.201C425.68 436.056 460.301 395.55 480.207 347.501C493.387 316.759 500.119 283.64 499.985 250.193C500.352 216.802 493.891 183.689 480.998 152.886Z"/></g></svg>';
  element.prepend(decor);
});

/*
// faq-accordion
*/
let accoFaq = document.querySelectorAll(".faq-accordion .faq__item");
if (accoFaq.length !== 0) {
  for (let i = 0; i < accoFaq.length; i++) {
    accoFaq[i].addEventListener("click", function (e) {
      const isActive = accoFaq[i].classList.contains("faq__item--active");
      for (let j = 0; j < accoFaq.length; j++) {
        accoFaq[j].classList.remove("faq__item--active");
      }
      if (!isActive) {
        accoFaq[i].classList.add("faq__item--active");
      }
    });
  }
}

/*
// faq-tabs
*/
let tabFaqLeft = document.querySelectorAll(".ctab__tabs-left .ctab__item");
let tabFaqRight = document.querySelectorAll(".ctab__tabs-right .ctab__item");
if (tabFaqLeft.length !== 0 && tabFaqRight.length !== 0) {
  tabFaqLeft[0].classList.add("ctab__item--active");
  tabFaqRight[0].classList.add("ctab__item--active");

  for (let i = 0; i < tabFaqLeft.length; i++) {
    tabFaqLeft[i].addEventListener("click", function (e) {
      const isActive = tabFaqLeft[i].classList.contains("ctab__item--active");
      if (!isActive) {
        for (let j = 0; j < tabFaqLeft.length; j++) {
          tabFaqLeft[j].classList.remove("ctab__item--active");
          tabFaqRight[j].classList.remove("ctab__item--active");
        }
        tabFaqLeft[i].classList.add("ctab__item--active");
        tabFaqRight[i].classList.add("ctab__item--active");
      }
    });
    let number = (i + 1).toString().padStart(2, "0");
    let titleText = tabFaqLeft[i].querySelector(".ctab__item-title");
    let span = document.createElement("span");
    span.classList.add("ctab__item-title-num");
    span.textContent = number;
    titleText.prepend(span);
  }

  // for (let i = 0; i < tabFaqRight.length; i++) {
  //   tabFaqRight[i].addEventListener("click", function (e) {
  //     const isActive = tabFaqRight[i].classList.contains("ctab__item--active");
  //     if (!isActive) {
  //       for (let j = 0; j < tabFaqRight.length; j++) {
  //         tabFaqRight[j].classList.remove("ctab__item--active");
  //         tabFaqLeft[j].classList.remove("ctab__item--active");
  //       }
  //       tabFaqRight[i].classList.add("ctab__item--active");
  //       tabFaqLeft[i].classList.add("ctab__item--active");
  //     }
  //   });
  // }
}

const header = document.querySelector(".site-header");
const toggleClass = "is-sticky";
window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll > 200) {
    header.classList.add(toggleClass);
  } else {
    header.classList.remove(toggleClass);
  }
});

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var images = document.querySelectorAll('img');

    images.forEach(function (img) {
      if (!img.classList.contains('video_poster')) {
        img.setAttribute('loading', 'lazy');
      }
    });
  });
})();
document.addEventListener('DOMContentLoaded', function () {
  var toTopButton = document.getElementById('js-top');
  window.addEventListener('scroll', function () {
    if (window.scrollY > 150) {
      toTopButton.classList.add('show');
    } else {
      toTopButton.classList.remove('show');
    }
  });
  toTopButton.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});